module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section02_img-296df1d39a6a27c35ce1fdfb48ac57f5.png";